export const DMS_MODULE = 'Kartoteka';

// Must stay here, moving to partner would cause a cyclic dependency with gdpr.
export const PARTNER = 'Partner';
